﻿import { isEmptyOrWhiteSpace } from "../../utils/string";
import { IEditor } from "../interface/editor";
import { ValidatorError } from "../types/validator-error";
import { ValidatorFn } from "../types/validator-fn";
import { ValidatorParam } from "../interface/validator-param";
import { isValidatorDisabled } from "./is-validator-disabled";


export interface requiredValidatorParam extends ValidatorParam {
    allowedWhiteSpace?: boolean | null;
    allowedFalse?: boolean | null
}

export function requiredValidator(param: requiredValidatorParam): ValidatorFn {

    return (editor: IEditor): ValidatorError | null => {
        if (isValidatorDisabled(param, editor)) {
            return null;
        }

        let message='Validate Failed';
        if(param.message) {
            message= param.message;
        }


        if (!isValid(editor.value, param)) {
            return { message: message };
        }

        if (Array.isArray(editor.value)) {
            if (editor.value.length === 0 ||
                (editor.value.length === 1 && !isValid(editor.value[0], param))) {
                return { message: message };
            }
        }

        return null;

    };
}

function isValid(value: any, param: requiredValidatorParam): boolean {
    if (value === undefined || value == null || value === '') {
        return false;
    }

    if (typeof (value) === 'string') {
        const allowedWhiteSpace = (param.allowedWhiteSpace == null || param.allowedWhiteSpace === undefined) ? false : param.allowedWhiteSpace;
        if (!allowedWhiteSpace && isEmptyOrWhiteSpace(value)) {
            return false;
        }
    } else if (Array.isArray(value) && value.length === 0) {
        return false;
    }

    const allowFalse = (param.allowedFalse == null || param.allowedFalse === undefined) ? false : param.allowedFalse;
    if (!allowFalse && value === false) {
        return false;
    }

    return true;
}